import { create } from "zustand";
import { GetInventoriesParams, SortByField } from "~/services/inventory";
import {
  CheckType,
  InventoryStatusCode,
  InventoryType,
  SortOrder,
} from "~/utils/constants";

type State = {
  formState: {
    open: boolean;
    inventoryId?: string;
    viewMode: boolean;
  };
  filters: GetInventoriesParams;
};

type Actions = {
  setFilters: (filters: Partial<GetInventoriesParams>) => void;
  resetFilters: () => void;
  openInventoryModal: (inventoryId?: string, viewMode?: boolean) => void;
  closeInventoryModal: () => void;
};

const initialState: GetInventoriesParams = {
  search: "",
  page: 1,
  pageSize: 10,
  checkParentId: CheckType.UNCHECK,
  itemType: "" as InventoryType,
  status: "" as InventoryStatusCode,
  clientId: "",
  locationId: "",
  sortBy: SortByField.INVENTORY_REF,
  sortOrder: SortOrder.ASC,
};

export const useInventoryStore = create<State & Actions>()((set) => ({
  formState: {
    open: false,
    viewMode: false,
  },
  filters: initialState,
  setFilters: (filters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  resetFilters: () => set({ filters: initialState }),
  openInventoryModal: (inventoryId, viewMode = false) =>
    set({
      formState: {
        open: true,
        inventoryId,
        viewMode,
      },
    }),
  closeInventoryModal: () =>
    set({
      formState: { open: false, inventoryId: undefined, viewMode: false },
    }),
}));
